import React from "react";
/** @jsxImportSource @emotion/react */
import { jsx, css } from "@emotion/react";
import { useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import { useState, forwardRef } from "react";
import Swal from "sweetalert2";
import axios from "axios";
import { useHistory } from "react-router-dom";
import Loading from "./Loading";
import Layout from "./Layout";
import { DataGrid } from "@mui/x-data-grid";
import AddIcon from "@mui/icons-material/Add";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import Slide from "@mui/material/Slide";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import CouponAdd from "./CouponAdd";
import CouponEdit from "./CouponEdit";
import pr from "../lib/pr";
import { loginState, configState } from "../lib/State";
import token_login from "../lib/token_login";
import get_session from "../lib/get_session";
import Popover from "@mui/material/Popover";
import Typography from "@mui/material/Typography";
import CloseIcon from "@mui/icons-material/Close";
import { AppBar, Toolbar, IconButton } from "@mui/material";
import CenterSelect from "./CenterSelect";
import get_login from "../lib/get_login";
import is_admin from "../lib/is_admin";
import CheckIcon from "@mui/icons-material/Check";
import { ko } from "date-fns/locale";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import Checkbox from "@mui/material/Checkbox";

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

function Coupon() {
  const [login, setLogin] = useState(loginState);
  const [loaded, setLoaded] = useState(false);
  const [rows, setRows] = useState([]);
  const [seq, setSeq] = useState(-1);
  const [showAdd, setShowAdd] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const token = localStorage.getItem("token");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [popPhone, setPopPhone] = useState("Hello");
  const [centers, setCenters] = useState([]);
  const [tcid, setTcid] = useState("");
  const open = Boolean(anchorEl);
  const [sname, setSname] = useState("");
  const [sphone, setSphone] = useState("");
  const [scoupon, setScoupon] = useState("");
  const [sdate, setSdate] = useState(null);
  const [edate, setEdate] = useState(null);
  const [tryCoupon, setTryCoupon] = useState(false);

  const columns = [
    { field: "id", headerName: "id", hide: true },
    {
      field: "class_date",
      headerName: "수업일",
      width: 120,
      align: "center",
    },
    {
      field: "hour",
      headerName: "시간",
      width: 80,
      align: "center",
    },
    {
      field: "pt_type",
      headerName: "타입",
      width: 80,
      align: "center",
    },
    {
      field: "mname",
      headerName: "회원명",
      width: 120,
      align: "center",
    },
    {
      field: "phone",
      headerName: "연락처",
      width: 120,
      align: "center",
    },
    {
      field: "coupon_seq",
      headerName: "쿠폰코드",
      width: 90,
      align: "center",
    },
    {
      field: "amount",
      headerName: "쿠폰단가",
      width: 120,
      align: "center",
    },
    {
      field: "tname",
      headerName: "강사명",
      width: 120,
      align: "center",
    },
    { field: "state", headerName: "상태", width: 80, align: "center" },
    {
      field: "point",
      headerName: "출석",
      width: 80,
      align: "center",
      renderCell: (params) => {
        const color = params.row.point === 1 ? "#3096F4" : "#cccccc";
        return <CheckIcon sx={{ color: color }}></CheckIcon>;
      },
    },
    { field: "regdate", headerName: "등록", width: 130, align: "center" },
    { field: "cname", headerName: "센터명", width: 180, align: "center" },
  ];

  // const rows = [
  //   {
  //     id: 1,
  //     name: "Snow",
  //     phone: "000-0000-0000",
  //     sex: "남",
  //     age: 35,
  //     weight: 55,
  //   }
  // ];

  const onCloseAddPop = () => {
    setShowAdd(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const onCloseEditPop = () => {
    setShowEdit(false);
    setTimeout(() => {
      window.location.reload();
    }, 300);
  };

  const onOpenAdd = () => {
    setShowAdd(true);
  };

  // 리스트
  const load_data = async () => {
    console.log("coupon : load_data");
    let result = await axios.post(
      configState.api + "/gympass_admin/reservation_log",
      {
        token: token,
        cid: login.cid,
        level: login.level,
        mcd: login.mcd,
        tcid: tcid,
        sname: sname,
        sphone: sphone,
        scoupon: scoupon,
        sdate: sdate,
        edate: edate,
        try_coupon: tryCoupon ? "Y" : "N",
      }
    );
    if (result.data.success === 1) {
      setRows(result.data.rows);
    } else {
      Swal.fire(result.data.msg);
      return;
    }
  };

  // ======================= //
  // 로그인
  // ======================= //
  const start = async () => {
    let result;
    result = await get_login();
    setLogin(result.data.login);
    result = await is_admin(result.data.login);
    if (!result) {
      window.location.href = "/";
    }
    setLoaded(true);
  };
  useEffect(() => {
    start();
  }, []);

  // 리스트
  useEffect(() => {
    if (loaded && tcid !== "") {
      load_data();
    }
  }, [loaded, tcid]);

  // 팝업처리
  const onPopoverOver = (event, message) => {
    setPopPhone(message);
    setAnchorEl(event.currentTarget);
  };

  const onPopoverOut = (event) => {
    setAnchorEl(null);
  };

  const onSearchClick = () => {
    pr("tcid=" + tcid);
    load_data();
  };

  return (
    <>
      {loaded === false ? (
        <Loading></Loading>
      ) : (
        <Layout login={login}>
          <Popover
            id="mouse-over-popover"
            sx={{
              pointerEvents: "none",
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
            transformOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            onClose={onPopoverOut}
            disableRestoreFocus
          >
            <Typography sx={{ p: 1 }}>{popPhone}</Typography>
          </Popover>

          <h3
            css={css`
              margin-top: 10px;
            `}
          >
            예약관리 (로그)
          </h3>

          <Box
            display="flex"
            css={css`
              text-align: right;
              max-width: 1300px;
              margin-bottom: 15px;
            `}
          >
            {/* 센터명 */}
            <CenterSelect
              login={login}
              tcidParent={tcid}
              setTcidParent={setTcid}
            />
          </Box>

          <Box display="flex" sx={{ mb: 1 }}>
            <Box>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                <DatePicker
                  label="시작일"
                  value={sdate}
                  onChange={(newValue) => {
                    newValue = moment(newValue).format("YYYY-MM-DD");
                    setSdate(newValue);                    
                    setEdate(moment(newValue).endOf('month').format("YYYY-MM-DD")                    );
                  }}
                  renderInput={(params) => (
                    <TextField sx={{ width: 150 }} size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
            </Box>

            <Box sx={{ ml: 1 }}>
              <LocalizationProvider dateAdapter={AdapterDateFns} locale={ko}>
                <DatePicker
                  label="종료일"
                  value={edate}
                  onChange={(newValue) => {
                    newValue = moment(newValue).format("YYYY-MM-DD");
                    setEdate(newValue);
                    if (sdate === null) {
                      setSdate(newValue);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField sx={{ width: 150 }} size="small" {...params} />
                  )}
                />
              </LocalizationProvider>
            </Box>

            {/* 이름 */}
            <Box sx={{ ml: 1 }}>
              <TextField
                sx={{ width: 120 }}
                name="sname"
                label="이름"
                size="small"
                onChange={(e) => setSname(e.target.value)}
                value={sname}
                autoComplete="off"
              ></TextField>
            </Box>

            {/* 연락처 */}
            <Box>
              <TextField
                sx={{ width: 160, ml: 1 }}
                name="sphone"
                label="연락처"
                size="small"
                onChange={(e) => setSphone(e.target.value)}
                autoComplete="off"
                value={sphone}
              ></TextField>
            </Box>

            {/* 쿠폰코드 */}
            <Box>
              <TextField
                sx={{ width: 120, ml: 1 }}
                name="scoupon"
                label="쿠폰코드"
                size="small"
                onChange={(e) => setScoupon(e.target.value)}
                autoComplete="off"
                value={scoupon}
              ></TextField>
            </Box>

            <Box>
              <Checkbox
                name="tryCoupon"
                onChange={(e) => setTryCoupon(e.target.checked)}
              ></Checkbox>
              체험쿠폰
            </Box>

            <Button
              sx={{ ml: 1, fontSize: 15 }}
              variant="contained"
              onClick={onSearchClick}
              size="small"
            >
              조회
            </Button>
          </Box>

          <DataGrid
            css={css`
              max-width: 1300px;
              min-height: 550px;
            `}
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[5]}
            checkboxSelection={false}
          />

          {/* 수정하기 팝업 */}
          <Dialog
            open={showEdit}
            TransitionComponent={Transition}
            onClose={() => {}}
            maxWidth="md"
          >
            <AppBar sx={{ position: "static" }}>
              <Toolbar>
                <Box sx={{ flexGrow: 1 }}>
                  <Typography style={{ fontSize: 18 }}>쿠폰수정</Typography>
                </Box>
                <IconButton
                  edge="start"
                  color="inherit"
                  onClick={onCloseEditPop}
                  aria-label="close"
                >
                  <CloseIcon />
                </IconButton>
              </Toolbar>
            </AppBar>
            <CouponEdit
              login={login}
              seq={seq}
              onClosePop={onCloseEditPop}
            ></CouponEdit>
          </Dialog>
        </Layout>
      )}
    </>
  );
}

export default Coupon;
